import {DeleteRecordsConfirmationButton,} from '@flexinet/ui-components';

import {useOffers} from '../hooks/useOffers.ts';
import {useOffersSelection} from "../hooks/useOffersSelection.ts";

export const DeleteRecordButton = () => {

    const {deleteRecords} = useOffers();

    const {
        selection,
        handleClearSelection,
    } = useOffersSelection();

    const recordIds = Object.keys(selection);
    let disabled = true;
    if (recordIds.length > 0) {
        disabled = false;
    }


    return (<DeleteRecordsConfirmationButton
        disabled={disabled}
        recordIdsLength={recordIds.length}
        handleConfirm={() => {
            deleteRecords()
            handleClearSelection()
        }}/>);
};
